import React from 'react';
import './Badge.css';

export type BadgeVariant = 'default' | 'success' | 'danger' | 'info' | 'warning';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    variant?: BadgeVariant;
}

export const Badge: React.FC<BadgeProps> = ({ variant = 'default', className = '', children, ...rest }) => (
    <span className={`cu-badge cu-badge--${variant} ${className}`.trim()} {...rest}>
        {children}
    </span>
);
